import React from 'react';
import { Background } from "@/components/background";
import { cn } from "@/lib/utils";
import { Contact2Form } from "@/components/contact2";
import { GridLineHorizontal, GridLineVertical } from "@/components/grid-lines";
import { Helmet } from 'react-helmet-async';
import { NavBar } from "@/components/navbar";
import { Footer } from '@/components/SiteFooter';

export default function Contact2Page() {
  return (
    <>
      <Helmet>
        <title>Contact Us (Alternative) - Everything AI</title>
        <meta 
          name="description" 
          content="Everything AI is a platform that provides a wide range of AI tools and services to help you stay on top of your business. Generate images, text and everything else that you need to get your business off the ground." 
        />
      </Helmet>
      
      <div className="min-h-screen flex flex-col">
        <NavBar />
        
        <div className="relative overflow-hidden py-20 md:py-0 px-4 md:px-20 bg-gray-50 dark:bg-black flex-grow">
          <div className="w-full min-h-screen grid grid-cols-1 md:grid-cols-2 relative overflow-hidden">
            <Background />
            
            {/* Left side - Contact Form */}
            <Contact2Form />
            
            {/* Right side - Feature highlights */}
            <div className="relative w-full z-20 hidden md:flex flex-col border-l border-neutral-100 dark:border-neutral-900 overflow-hidden bg-gray-50 dark:bg-black items-center justify-center p-8">
              {/* Grid lines only for the right column */}
              <div className="absolute inset-0 z-0">
                <GridLineHorizontal />
                <GridLineVertical />
              </div>
              <div className="max-w-lg mx-auto">
                <h2 className="text-3xl font-bold text-black dark:text-white mb-6">
                  Smart AI Solutions for Your Business
                </h2>
                
                <div className="space-y-6">
                  <div className="bg-white dark:bg-neutral-900 rounded-lg p-4 shadow-sm border border-neutral-200 dark:border-neutral-800">
                    <h3 className="text-lg font-semibold text-black dark:text-white mb-2">
                      Document Extraction
                    </h3>
                    <p className="text-neutral-600 dark:text-neutral-300 text-sm">
                      Automated extraction of structured data from compliance documents, forms, and regulatory filings. 
                      Reduces manual data entry by 65% and minimizes transcription errors.
                    </p>
                  </div>
                  
                  <div className="bg-white dark:bg-neutral-900 rounded-lg p-4 shadow-sm border border-neutral-200 dark:border-neutral-800">
                    <h3 className="text-lg font-semibold text-black dark:text-white mb-2">
                      AI Document Summary
                    </h3>
                    <p className="text-neutral-600 dark:text-neutral-300 text-sm">
                      AI-powered extraction of key points, requirements, and obligations from lengthy regulatory 
                      documents and compliance texts. Reduces document review time by 81% while improving comprehension.
                    </p>
                  </div>
                  
                  <div className="bg-white dark:bg-neutral-900 rounded-lg p-4 shadow-sm border border-neutral-200 dark:border-neutral-800">
                    <h3 className="text-lg font-semibold text-black dark:text-white mb-2">
                      Compliance Tracking
                    </h3>
                    <p className="text-neutral-600 dark:text-neutral-300 text-sm">
                      Continuous monitoring of compliance status across all regulatory requirements. Real-time 
                      tracking of control effectiveness and compliance gaps. Improves compliance visibility by 88%.
                    </p>
                  </div>
                </div>
                
                <div className="mt-8 text-center">
                  <p className="text-lg font-medium text-blue-600 dark:text-blue-400">
                    Total Annual Savings
                  </p>
                  <p className="text-3xl font-bold text-black dark:text-white">
                    €450,000+
                  </p>
                  <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-2">
                    Based on average customer implementation
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <Footer />
      </div>
    </>
  );
}